import React , {useContext} from 'react'
import OrderedItems from "./OrderedItems.jsx";
import CartContext from '../../../../context/cart_context.js';

const OrderedItemsList = () => {
  const {selectedfoodItemList , cartItems} = useContext(CartContext);
  return (
    <div className='checkout-item-container'>
        {
          Object.keys(cartItems).map((value, index ) => {
            const item = selectedfoodItemList.find((food) => food.dbID == value  )
            console.log(value);
            return <OrderedItems key={value} item={item} count={cartItems[value]} isLast={index=== selectedfoodItemList.length -1 }  />
          } )
        }
    </div>
  )
}

export default OrderedItemsList